import { render, staticRenderFns } from "./TutorialDialogue.vue?vue&type=template&id=143d61a8&"
import script from "./TutorialDialogue.vue?vue&type=script&lang=js&"
export * from "./TutorialDialogue.vue?vue&type=script&lang=js&"
import style0 from "./TutorialDialogue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports